// extracted by mini-css-extract-plugin
export default {"root":"aKQTvJgC","withPlaceholder":"T5uhxb0q"};